import { useMutation } from 'react-query';
import { Auth } from 'aws-amplify';

const unsetMfaRequirement = async () => {
  const user = await Auth.currentAuthenticatedUser();
  await Auth.updateUserAttributes(user, {
    'custom:mfaRequirement': '',
  });
};

export function useMutateUnsetMfaRequirement() {
  return useMutation(unsetMfaRequirement);
}
